import { FC, useState } from 'react';
import { useTranslation } from 'next-i18next';
import styled from 'styled-components';

import { useI18nValues } from '@/entities/vfo/hooks/useI18nValues';
import { Tags } from '@/entities/vfo/types';
import { Checkbox } from '@/features/vfo/components/Checkbox';
import { breakpoints, media } from '@/shared/components';
import { Button } from '@/shared/uikitV2/Button';
import { useModalsStore } from '@/widgets/modals/modals.store';
import { SelectTagModalProps } from '@/widgets/modals/types';

import { ModalContainerV1 } from '../../interwill/containers/ModalContainerV1';

const tagsArray = Object.values(Tags);

export const SelectTagModal: FC<SelectTagModalProps> = ({ onFinish, initialTags }) => {
  const { t } = useTranslation('widgets/modals', { keyPrefix: 'selectTags' });

  const [selectedTags, setSelectedTags] = useState<Tags[]>(initialTags ?? []);
  const { tag } = useI18nValues();

  const { closeModal } = useModalsStore();

  const handleToggle = async (selected: Tags) => {
    setSelectedTags((prev) =>
      prev.includes(selected) ? prev.filter((m) => m !== selected) : [...prev, selected],
    );
  };

  return (
    <ModalContainerV1 title={t('title')}>
      <ListContainer>
        {tagsArray.map((item) => {
          return (
            <ListItem key={item} onClick={() => handleToggle(item)}>
              <Checkbox
                style={{
                  pointerEvents: 'none',
                }}
                checked={selectedTags.includes(item)}
              />
              <span>{tag(item)}</span>
            </ListItem>
          );
        })}
      </ListContainer>
      <Buttons>
        <Button
          size="middle"
          onClick={() => {
            closeModal();
            onFinish?.(selectedTags);
          }}
        >
          {t('save')}
        </Button>
      </Buttons>
    </ModalContainerV1>
  );
};

const ListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  overflow-y: auto;
  padding: 24px;

  ${media.md}, ${breakpoints.sm} {
    padding: 0;
  }
`;

const ListItem = styled.div`
  display: flex;
  align-items: center;
  padding: 12px;
  cursor: pointer;
  gap: 16px;
  font-size: 14px;
`;

const Buttons = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 16px 24px;

  ${media.md}, ${breakpoints.sm} {
    flex-direction: column;
    margin-top: auto;
  }
`;
